import { isEqual } from 'lodash-es';
import { useEffect, useState } from 'react';

// AG-Grid unmounts and remounts the detail cell renderer on every server-side refresh.
export function useShouldReloadSensitivityDataOnMount<T extends { quoteId: string }>(
  data: T | undefined,
  snapshotMap: Map<string, T>,
) {
  const [shouldRefresh] = useState(() => {
    if (data === undefined) {
      return false;
    }
    const previousSnapshot = snapshotMap.get(data.quoteId);
    return previousSnapshot !== undefined && !isEqual(previousSnapshot, data);
  });

  useEffect(() => {
    if (data !== undefined) {
      snapshotMap.set(data.quoteId, data);
    }
  }, [data, snapshotMap]);

  return shouldRefresh;
}
